import { FC } from 'react';
import { ENV_CONFIG } from 'config/environment';

interface Props {
  primaryContact?: { name: string | null; email: string | null } | null;
}

// TODO(OATH-4302): replace with final wording from Design before this ships to campaigns.
const formatContactLine = (
  primaryContact: { name: string | null; email: string | null },
  supportEmail: string
) => {
  const { name, email } = primaryContact;
  const emailLink = email ? <a href={`mailto:${email}`}>{email}</a> : null;
  const supportLink = <a href={`mailto:${supportEmail}`}>{supportEmail}</a>;

  if (name && email) {
    return (
      <>
        Your Primary Contact is {name} ({emailLink}). Reach out to them to request a change.
      </>
    );
  } else if (name) {
    return (
      <>
        Your Primary Contact is {name}. Contact {supportLink} for their email address.
      </>
    );
  } else if (email) {
    return (
      <>Your Primary Contact&apos;s email is {emailLink}. Reach out to them to request a change.</>
    );
  }
  return (
    <>
      No Primary Contact is set for this account. Email {supportLink} to have one designated, and
      you will be able to manage admins here.
    </>
  );
};

export const PrimaryContactCard: FC<Props> = ({ primaryContact }) => {
  return (
    <div className="content-full-width recipient-admins-content">
      <span className="oath-h3 inkBlue">Admins</span>
      <p className="oath-body inkBlue mt-2">
        Only your account&apos;s Primary Contact can manage admins.{' '}
        {formatContactLine(
          primaryContact ?? { name: null, email: null },
          ENV_CONFIG().RECIPIENTS_SUPPORT_EMAIL
        )}
      </p>
    </div>
  );
};
